import { render, staticRenderFns } from "./foreUPTeesheets.vue?vue&type=template&id=f27b367a&scoped=true"
import script from "./foreUPTeesheets.vue?vue&type=script&lang=js"
export * from "./foreUPTeesheets.vue?vue&type=script&lang=js"
import style0 from "./foreUPTeesheets.vue?vue&type=style&index=0&id=f27b367a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27b367a",
  null
  
)

export default component.exports